import { parseServerDate } from "../../utils/time";

// Founder revenue formatter — hardcoded EUR because Stripe charges
// tenants in EUR regardless of what currency their guests see. Don't
// migrate this to formatPrice/getCurrency — those are for tenant-facing
// guest prices (which vary: Br in Ethiopia, € in NL), not for the
// founder's own SaaS MRR which is always in Euro.
export function fmtEur(n) {
  if (n == null || isNaN(n)) return "—";
  return "€" + Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return parseServerDate(iso).toLocaleDateString(); } catch { return "—"; }
}

export function fmtRating(r) {
  if (r == null) return "—";
  return "★ " + Number(r).toFixed(1);
}

export function pct(numerator, denominator) {
  if (!denominator) return null;
  return Math.round((numerator / denominator) * 100);
}

export function fmtRelativeTime(iso) {
  if (!iso) return "never";
  const ts = parseServerDate(iso).getTime();
  if (isNaN(ts)) return "never";
  const mins = Math.floor((Date.now() - ts) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const h = Math.floor(mins / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  const mo = Math.floor(d / 30);
  return `${mo}mo ago`;
}

export function fmtDaysUntil(iso) {
  if (!iso) return null;
  const ts = parseServerDate(iso).getTime();
  if (isNaN(ts)) return null;
  const days = Math.ceil((ts - Date.now()) / 86400000);
  if (days <= 0) return "ended";
  if (days === 1) return "tomorrow";
  return `in ${days}d`;
}
